import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const ChatHistoryEmpty = () => {
  return (
    <Box padding="5px" paddingBottom="16px">
      <Typography color="textSecondary" variant="body2" />
    </Box>
  );
};

export default ChatHistoryEmpty;
